import { Link } from 'gatsby';

import { Grid2 as Grid } from '@mui/material';

import { LinkTabs, ResponsiveGrid } from '@mewa/ui';

import NoTabsSpacer from './industry-no-tabs-spacer';

export const IndustryStickyTabs = ({
  links,
  selectedIndex,
}: {
  links: { label: string; to: string }[];
  selectedIndex: number;
}) => (
  <ResponsiveGrid
    sx={{
      position: 'sticky',
      top: 'calc(var(--header-sticky-position) + var(--header-height))', // just below header
      transition: 'top var(--transition-duration)',
      backgroundColor: 'var(--color-white)',
      zIndex: 1,
    }}
  >
    <Grid size={12}>
      <LinkTabs
        links={links}
        LinkComponent={Link}
        selectedIndex={selectedIndex}
      />
      <NoTabsSpacer />
    </Grid>
  </ResponsiveGrid>
);
